import { Observable, performDraw, SESSION_NOT_TRACKED, startSessionManager } from '@datadog/browser-core';
export var LOGS_SESSION_KEY = 'logs';
export function startLogsSessionManager(configuration, trackingConsentState) {
  var sessionManager = startSessionManager(configuration, LOGS_SESSION_KEY, function (rawTrackingType) {
    return computeTrackingType(configuration, rawTrackingType);
  }, trackingConsentState);
  return {
    findTrackedSession: function findTrackedSession(startTime) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        returnInactive: false
      };
      var session = sessionManager.findSession(startTime, options);
      return session && session.trackingType === "1"
      /* LoggerTrackingType.TRACKED */
      ? {
        id: session.id,
        anonymousId: session.anonymousId
      } : undefined;
    },
    expireObservable: sessionManager.expireObservable
  };
}
export function startLogsSessionManagerStub(configuration) {
  var isTracked = computeTrackingType(configuration) === "1"
  /* LoggerTrackingType.TRACKED */
  ;
  var session = isTracked ? {} : undefined;
  return {
    findTrackedSession: function findTrackedSession() {
      return session;
    },
    expireObservable: new Observable()
  };
}

function computeTrackingType(configuration, rawTrackingType) {
  if (hasValidLoggerSession(rawTrackingType)) {
    return rawTrackingType;
  }

  if (!performDraw(configuration.sessionSampleRate)) {
    return "0"
    /* LoggerTrackingType.NOT_TRACKED */
    ;
  }

  return "1"
  /* LoggerTrackingType.TRACKED */
  ;
}

function hasValidLoggerSession(trackingType) {
  return trackingType === "0"
  /* LoggerTrackingType.NOT_TRACKED */
  || trackingType === "1"
  /* LoggerTrackingType.TRACKED */
  ;
}